import React from "react";
import Cookies from "js-cookie";
import {
  Button,
  FormGroup,
  Input,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Label,
  Container,
  Alert,
} from "reactstrap";
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import api from "../../api";

import Select from "react-select";
import SiteTextInput from "components/SiteTextInput";
import SiteDropdownInput from "components/SiteDropdownInput";
import constants from "../../constants";
import "./index.css";

const STATUS_FILTER = [
  // { label: "All", value: "all" },
  { label: "Mới", value: "new" },
  { label: "Đang kiểm tra", value: "checking" },
  { label: "Xem lại sau", value: "saved-for-later" },
  { label: "Duyệt", value: "approved" },
  { label: "Từ chối", value: "rejected" },
];

const FLOOR_COUNT_LIST = [
  {
    label: 1,
    value: 1,
  },
  {
    label: 2,
    value: 2,
  },
  {
    label: 3,
    value: 3,
  },
  {
    label: 4,
    value: 4,
  },
  {
    label: 5,
    value: 5,
  },
];

const CONTACT_ROLE_LIST = [
  {
    label: "Chủ nhà",
    value: "host",
  },
  {
    label: "Người môi giới",
    value: "real-estate-agent",
  },
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class ExternalSiteEditScreen extends React.Component {
  constructor(props) {
    super(props);
    this.externalSiteId =
      parseInt(this.props.match.params.external_site_id, 10) || 0;
    this.state = {
      site: this.props.site || {
        address_number: "",
        street_name: "",
        latitude: "",
        longitude: "",
        store_format: {
          id: "",
          name: "",
        },
        area: "",
        facade_length: "",
        initial_lease_rate: "",
        contact_name: "",
        contact_phone: "",
        contact_email: "",
        description: "",
      },
      activeTab: "1",
      labelNames: this.props.labelNames || [],
      isLoading: false,
      isUploading: false,
      isView: this.props.isView || false,
      selectedCaptions: {},
      selectedPhotos: null,
      selectedFloorCount: FLOOR_COUNT_LIST[0],
      selectedContactRole: CONTACT_ROLE_LIST[0],
      selectedStatus: STATUS_FILTER[0],
      // selectedStatus: STATUS_FILTER.find(item => {
      //   return item.value === (site ? site.external_status : "");
      // }),
    };
    this.updateAttr = this.updateAttr.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.getCurrentUser();
    if (!this.props.site) {
      this.getSiteDetail();
      this.getSiteFieldInfo();
    }
  }

  validateSiteInfoCheck() {
    const { site, labelNames } = this.state;
    const alertMessage = [];
    constants.EXTERNAL_SITE_REQUIRED_FIELDS.map((requiredField) => {
      if (!site[requiredField]) {
        const fieldName = labelNames[requiredField];
        alertMessage.push(`${fieldName} không được để trống`);
      }
    });
    if (alertMessage) {
      this.setState({
        alertMessage,
      });
    } else {
      alert("Everything is good");
    }
  }
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: (response) => {
        if (response.result) {
          const currentUser = response.result;
          this.setState({
            currentUser,
          });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  getSiteFieldInfo() {
    api.fetchAPI({
      method: "get",
      uri: `external_site/_info`,
      success: (response) => {
        const labelNames = {};
        response.edit_columns.map((eachColumn) => {
          if (
            !eachColumn.label.includes("địa điểm mặt bằng") &&
            eachColumn.label.includes("mặt bằng")
          ) {
            labelNames[eachColumn.name] = eachColumn.label.replace(
              "mặt bằng",
              "địa điểm"
            );
          } else {
            labelNames[eachColumn.name] = eachColumn.label;
          }
        });
        this.setState({
          labelNames,
          isLoading: false,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getSiteDetail() {
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "get",
      uri: `external_site/${this.externalSiteId}`,
      success: async (response) => {
        this.setState({
          selectedStatus: STATUS_FILTER.find((item) => {
            return item.value === response.result.status;
          }),
          selectedFloorCount: FLOOR_COUNT_LIST.find((item) => {
            return item.value === response.result.floor_count;
          }),
          selectedContactRole: CONTACT_ROLE_LIST.find((item) => {
            return item.value === response.result.contact_role;
          }),
          site: response.result,
          labelNames: response.label_columns,
          isLoading: false,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  saveSite(exitAfterSave) {
    const {
      site,
      selectedPhotos,
      isCreate,
      currentUser,
      alertMessage,
      selectedCaptions,
    } = this.state;

    console.log(site);

    this.validateSiteInfoCheck();

    site.changed_by = {
      id: currentUser.id,
    };

    this.setState({ isLoading: true });

    api.fetchAPI({
      method: "put",
      uri: `external_site/${this.externalSiteId}`,
      body: site,
      success: async (response) => {
        console.log(response);
        if (response.result) {
          // Upload photos, if any
          if (selectedPhotos) {
            alert("Will upload photos, please be patient ^^");
            await this.uploadImage().then(() => {
              if (exitAfterSave)
                window.location = `/external_site/${this.externalSiteId}`;
            });
          } else {
            if (selectedCaptions) {
              await this.updateImageCaption();
            }
            if (exitAfterSave)
              window.location = `/external_site/${this.externalSiteId}`;
          }
          this.setState({
            isUploading: false,
            isLoading: false,
          });
        }
      },
      error: (error) => {
        console.log(error);
        alert(error.msg);
        this.setState({ isLoading: false });
      },
    });
    this.setState({ isLoading: false });
  }
  async uploadImage() {
    const { site, selectedPhotos, selectedCaptions } = this.state;
    this.setState({ isUploading: true });

    const promiseAll = [];
    Object.keys(selectedPhotos).forEach(async (photoAttribute, index) => {
      if (!selectedCaptions[photoAttribute]) {
        selectedCaptions[photoAttribute] = {};
      }

      if (!selectedCaptions[photoAttribute]["caption_text"]) {
        selectedCaptions[photoAttribute]["caption_text"] = "";
      }

      const submitData = new FormData();
      submitData.set("user_file", selectedPhotos[photoAttribute]["url"]);
      submitData.set(
        "caption_text",
        selectedCaptions[photoAttribute]["caption_text"]
      );

      promiseAll.push(
        api.fetchAPI({
          method: "post",
          body: submitData,
          uri: `externalsitefiles/${site.id}/photo_upload/${photoAttribute}`,
          success: (response) => {
            console.log(response);
          },
        })
      );
    });
    await Promise.all(promiseAll);
  }
  async updateImageCaption() {
    const { site, selectedCaptions } = this.state;
    this.setState({ isUploading: true });

    const promiseAll = [];
    Object.keys(selectedCaptions).forEach(async (photoAttribute, index) => {
      const submitData = new FormData();
      submitData.set(
        "caption_text",
        selectedCaptions[photoAttribute]["caption_text"]
      );

      promiseAll.push(
        api.fetchAPI({
          method: "post",
          body: submitData,
          uri: `externalsitefiles/${site.id}/photo_caption_update/${photoAttribute}`,
          success: (response) => {
            console.log(response);
          },
        })
      );
    });
    await Promise.all(promiseAll);
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    if (value == "") value = null;
    if (attribute === "city") {
      site["district"] = null;
      site["ward"] = null;
    }
    if (attribute === "district") {
      site["ward"] = null;
    }
    site[attribute] = value;
    this.setState({ site });
  }
  deleteAttachment(attachment_location_id, imageAttribute) {
    const confirm = window.confirm("Bạn có chắc sẽ xóa ảnh này?");
    if (!confirm) return;

    const { site } = this.state;

    api.fetchAPI({
      method: "put",
      body: {
        is_active: 0,
      },
      uri: `file_attachment/${attachment_location_id}`,
      success: (response) => {
        if (response.result) {
          site.photos[imageAttribute] = null;
          this.setState({ site });
        }
      },
    });
  }
  onPhotoSelected(event, imageAttribute) {
    let { selectedPhotos, selectedCaptions, site } = this.state;
    if (!selectedPhotos) {
      selectedPhotos = {};
    }
    if (!selectedPhotos[imageAttribute]) {
      selectedPhotos[imageAttribute] = {};
    }
    if (!selectedCaptions[imageAttribute]) {
      selectedCaptions[imageAttribute] = {};
    }

    if (!site.photos) {
      site.photos = {};
    }
    if (!site.photos[imageAttribute]) {
      site.photos[imageAttribute] = {};
    }
    if (site.photos[imageAttribute]) {
      site.photos[imageAttribute]["caption_text"] = "";
      site.photos[imageAttribute]["url"] = "";
    }

    selectedPhotos[imageAttribute]["url"] = event.target.files[0];
    selectedCaptions[imageAttribute]["caption_text"] = "";
    this.setState({ selectedPhotos, site });
    // let { selectedPhotos } = this.state;
    // if (!selectedPhotos) {
    //   selectedPhotos = {};
    // }
    // selectedPhotos[imageAttribute] = event.target.files[0];
    // this.setState({ selectedPhotos });
  }
  onPhotoCaptionChangeSelected(text, imageAttribute) {
    let { selectedCaptions, site } = this.state;
    if (!selectedCaptions) {
      selectedCaptions = {};
    }
    if (!selectedCaptions[imageAttribute]) {
      selectedCaptions[imageAttribute] = {};
    }
    selectedCaptions[imageAttribute]["caption_text"] = text;

    if (!site.photos[imageAttribute]) {
      site.photos[imageAttribute] = {};
    }

    if (!site.photos[imageAttribute]["caption_text"]) {
      site.photos[imageAttribute]["caption_text"] = "";
    }
    site.photos[imageAttribute]["caption_text"] = text;

    this.setState({ selectedCaptions, site });
  }
  findSiteLatLng() {
    const r = window.confirm(
      "Dữ liệu lat, lng lấy tự động có thể bị sai, vui lòng kiểm tra lại trên bản đồ và điều chỉnh nếu cần. Bạn có muốn tiếp tục?"
    );
    if (!r) return;
    const { site } = this.state;
    const full_address = `${site.address_number} ${site.street_name}, ${
      site.ward ? site.ward.name : ""
    }, ${site.district ? site.district.name : ""}, ${
      site.city ? site.city.name : ""
    }`;
    api.fetchAPI({
      method: "get",
      uri: `location/geocoding/address_to_lat_lng?address=${full_address}`,
      success: (response) => {
        site.latitude = response.result.latitude;
        site.longitude = response.result.longitude;
        this.setState({ site });
      },
      error: (response) => {
        alert("Error: " + response.msg);
      },
    });
  }
  toggle(tab) {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }
  render() {
    const {
      site,
      labelNames,
      isLoading,
      isUploading,
      selectedPhotos,
      isView,
      activeTab,
      selectedFloorCount,
      selectedContactRole,
      alertMessage,
      selectedStatus,
    } = this.state;
    return (
      <Container>
        {!isView && (
          <div>
            <h1>{`Chỉnh sửa`}</h1>
            <div>
              <Button
                color={isLoading || isUploading ? "secondary" : "success"}
                onClick={() => this.saveSite(true)}
                disabled={isLoading || isUploading}
              >
                {isLoading
                  ? "Đang lưu..."
                  : isUploading
                  ? "Đang upload hình"
                  : "Lưu"}
              </Button>{" "}
              <Button
                color="warning"
                onClick={() => this.validateSiteInfoCheck()}
              >
                Kiểm tra dữ liệu
              </Button>
            </div>
          </div>
        )}
        {alertMessage && alertMessage.length > 0 && (
          <Row className="site-edit__error-message-on-save">
            <Col xs={12}>
              <Alert color="danger">
                <h4>Các thông tin còn thiếu:</h4>
                <ol>
                  {alertMessage.map((message) => (
                    <li key={message}>{message}</li>
                  ))}
                </ol>
              </Alert>
            </Col>
          </Row>
        )}
        <Nav tabs className="site-edit__tabs">
          <NavItem>
            <NavLink
              className={`site-edit__tabs-nav-link ${
                activeTab === "1" ? "active" : ""
              }`}
              onClick={() => {
                this.toggle("1");
              }}
            >
              Thông tin chung
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Trạng thái</h2>
              <Row>
                <Col xs={12} sm={6}>
                  <Select
                    isDisabled={isView}
                    options={STATUS_FILTER}
                    value={selectedStatus}
                    onChange={(selectedOption) => {
                      this.setState({
                        site: {
                          ...site,
                          ...{ status: selectedOption.value },
                        },
                        selectedStatus: selectedOption,
                      });
                    }}
                  />
                </Col>
              </Row>
            </div>
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Địa chỉ mặt bằng</h2>
              <Row>
                <Col xs={12} sm={6}>
                  <SiteDropdownInput
                    apiUrl="city/"
                    callback={this.updateAttr}
                    value={{
                      label: site.city ? site.city.name : "",
                      value: site.city ? site.city.id : "",
                    }}
                    placeholder="Chọn thành phố"
                    site={site}
                    labels={labelNames}
                    attributeName="city"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteDropdownInput
                    apiUrl={`district/?q=(filters:!((col:city,opr:rel_o_m,value:${
                      site.city ? site.city.id : null
                    })))`}
                    callback={this.updateAttr}
                    value={{
                      label: site.district ? site.district.name : "",
                      value: site.district ? site.district.id : "",
                    }}
                    // filter={{
                    //   field: "city_id",
                    //   value: site.city ? site.city.id : "",
                    // }}
                    placeholder="Chọn quận, huyện"
                    site={site}
                    labels={labelNames}
                    attributeName="district"
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={2}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="address_number"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="street_name"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  {/* <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="ward_name"
                    disabled={isView}
                  /> */}
                  <SiteDropdownInput
                    apiUrl={`ward/?q=(filters:!((col:district,opr:rel_o_m,value:${
                      site.district ? site.district.id : null
                    })))`}
                    callback={this.updateAttr}
                    value={{
                      label: site.ward ? site.ward.name : "",
                      value: site.ward ? site.ward.id : "",
                    }}
                    // filter={{
                    //   field: "district_id",
                    //   value: site.district ? site.district.id : "",
                    // }}
                    placeholder="Chọn phường, xã"
                    site={site}
                    labels={labelNames}
                    attributeName="ward"
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={3}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="longitude"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6} md={3}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="latitude"
                    disabled={isView}
                  />
                </Col>
                {!isView && (
                  <Col xs={12} md={3}>
                    <Label>Lấy lat long tự động</Label>
                    <Button color="info" onClick={() => this.findSiteLatLng()}>
                      Find Lat Long
                    </Button>
                  </Col>
                )}
              </Row>
            </div>
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Thông tin mặt bằng</h2>
              <Row>
                <Col xs={12} sm={6}>
                  <SiteDropdownInput
                    apiUrl="store_format/"
                    callback={this.updateAttr}
                    value={{
                      label: site.store_format.name,
                      value: site.store_format.id,
                    }}
                    site={site}
                    labels={labelNames}
                    attributeName="store_format"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="area"
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Label>{labelNames["floor_count"]}</Label>
                  <Select
                    isDisabled={isView}
                    options={FLOOR_COUNT_LIST}
                    value={selectedFloorCount}
                    onChange={(selectedOption) => {
                      this.setState({
                        site: {
                          ...site,
                          ...{ floor_count: selectedOption.value },
                        },
                        selectedFloorCount: selectedOption,
                      });
                    }}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="facade_length"
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="initial_lease_rate"
                    isNumeric
                    disabled={isView}
                  />
                </Col>
              </Row>
            </div>
            <div className="site-edit__section">
              <h2 className="site-edit__section-title">Thông tin liên hệ</h2>
              <Row>
                <Col xs={12} sm={6}>
                  <Label>{labelNames["contact_role"]}</Label>
                  <Select
                    isDisabled={isView}
                    options={CONTACT_ROLE_LIST}
                    value={selectedContactRole}
                    onChange={(selectedOption) => {
                      this.setState({
                        site: {
                          ...site,
                          ...{ contact_role: selectedOption.value },
                        },
                        selectedContactRole: selectedOption,
                      });
                    }}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="contact_name"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="contact_phone"
                    disabled={isView}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SiteTextInput
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="contact_email"
                    disabled={isView}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <SiteTextInput
                    textArea
                    site={site}
                    labels={labelNames}
                    callback={this.updateAttr}
                    attributeName="description"
                    disabled={isView}
                  />
                </Col>
              </Row>
            </div>
            {!isView && (
              <div className="site-edit__section">
                <h2 className="site-edit__section-title">Hình ảnh</h2>
                <Row>
                  {constants.EXTERNAL_SITE_IMAGE_ATTRIBUTES.map(
                    (imageAttribute) => (
                      <Col xs={12} sm={6} key={imageAttribute}>
                        {!isView && (
                          <div>
                            <FormGroup>
                              <Label>{labelNames[imageAttribute]}</Label>
                              <Input
                                type="file"
                                onChange={(event) =>
                                  this.onPhotoSelected(event, imageAttribute)
                                }
                              >
                                Chọn ảnh nha
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Input
                                type="text"
                                placeholder="Ghi chú"
                                value={
                                  site &&
                                  site.photos &&
                                  site.photos[imageAttribute]
                                    ? site.photos[imageAttribute][
                                        "caption_text"
                                      ]
                                    : ""
                                }
                                onChange={(event) =>
                                  this.onPhotoCaptionChangeSelected(
                                    event.target.value,
                                    imageAttribute
                                  )
                                }
                              />
                            </FormGroup>
                            {selectedPhotos && (
                              <div className="site-edit__img-container">
                                {selectedPhotos[imageAttribute] &&
                                  selectedPhotos[imageAttribute]["url"] && (
                                    <img
                                      className="site-edit__img"
                                      src={URL.createObjectURL(
                                        selectedPhotos[imageAttribute]["url"]
                                      )}
                                    />
                                  )}
                              </div>
                            )}
                          </div>
                        )}
                        {site.photos && (
                          <div className="site-edit__img-container">
                            {isView && (
                              <Label>{labelNames[imageAttribute]}</Label>
                            )}
                            {selectedPhotos &&
                            selectedPhotos[imageAttribute] &&
                            selectedPhotos[imageAttribute] ? null : (
                              <div>
                                {site.photos[imageAttribute] &&
                                  site.photos[imageAttribute]["url"] && (
                                    <div>
                                      <img
                                        className="site-edit__img"
                                        src={site.photos[imageAttribute]["url"]}
                                      />
                                      <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() =>
                                          this.deleteAttachment(
                                            site.photos[imageAttribute][
                                              "attachment_location_id"
                                            ],
                                            imageAttribute
                                          )
                                        }
                                      >
                                        Xóa
                                      </Button>
                                    </div>
                                  )}
                              </div>
                            )}
                          </div>
                        )}
                      </Col>
                    )
                  )}
                </Row>
              </div>
            )}
          </TabPane>
        </TabContent>
      </Container>
    );
  }
}
